import { render, staticRenderFns } from "./activityclassfy.vue?vue&type=template&id=17c9d6d9&scoped=true&"
import script from "./activityclassfy.vue?vue&type=script&lang=js&"
export * from "./activityclassfy.vue?vue&type=script&lang=js&"
import style0 from "./activityclassfy.vue?vue&type=style&index=0&id=17c9d6d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c9d6d9",
  null
  
)

export default component.exports